import { GRAPHQL_URL } from "../../constants";
import { fetch } from "../../index";
import { multipleLineup } from "../../queries/allContentItems";
import { REGIONS_VISIBLE_IN_NAV } from "../../../../utils/regions/library";

export const fetch_regions = async (cardCount) => {
    return await fetch(
        GRAPHQL_URL,
        {
            query: multipleLineup(REGIONS_VISIBLE_IN_NAV, cardCount),
        },
        false
    );
};
